<template>
  <div>
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">Notre équipe</h2>
            <p class="lead text-muted">
              Un groupe de jeunes dynamiques prêts à faire de vos campagnes
              publicitaires un véritable succès.
            </p>
          </div>
        </div>

        <div class="row">
          <div
            class="col-md-6 col-lg-3 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="3000"
            v-for="(item, index) in allMembers"
            :key="index"
          >
            <div class="px-2 pt-4 imgDiv">
              <img
                v-lazy="item.image"
                :alt="item.alt"
                id="membreImg"
                class="img-center img-fluid shadow shadow-lg--hover"
              />

              <div class="text-div">
                <h6 class="title titre">
                  <div class="d-block mb-1 name">{{ item.lastname }}</div>
                  <!-- <div>{{ item.firstname }}</div> -->
                  <small class="h7 role">{{ item.role }}</small>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import cedric from "@/../public/img/theme/cedric.jpg";
import grace from "@/../public/img/theme/grace.jpg";
import khaliq from "@/../public/img/theme/khaliq.jpg";
import sam from "@/../public/img/theme/sam.jpg";
import noel from "@/../public/img/theme/noel.jpg";
import david from "@/../public/img/theme/david.jpg";
import marius from "@/../public/img/theme/marius.jpg";
import john from "@/../public/img/theme/john.jpg";
import bertrand from "@/../public/img/theme/bertrand.jpg";
import steeve from "@/../public/img/theme/steeve.jpg";
import alexandre from "@/../public/img/theme/alexandre.jpg";
import godfroy from "@/../public/img/theme/godfroy.jpg";
import carlos from "@/../public/img/theme/carlosTok.jpg";
import xavier from "@/../public/img/theme/xavier.jpg";
import jolidon from "@/../public/img/theme/jolidon.jpg";
import vanessa from "@/../public/img/theme/vanessa.jpg";
import manu from "@/../public/img/theme/manu.jpg";
import conceptia from "@/../public/img/theme/conceptia.jpg";
import simeon from "@/../public/img/theme/simeon.jpg";
import aaron from "@/../public/img/theme/aaron.jpg";

export default {
  name: "home",
  components: {},
  data() {
    return {
      allMembers: [
        {
          alt: "Panneau mobile bénin. Vélo publicitaire Cédric TOKPONSI",
          lastname: "M. Cédric ",
          firstname: "",
          image: cedric,
          role: "Directeur Exécutif",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Grâce ALOHOUTADE",
          lastname: "Mme Grâce ",
          firstname: "",
          image: grace,
          role: "Responsable Commercial",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Khaliq Ali",
          lastname: "M. Khaliq ",
          firstname: "",
          image: khaliq,
          role: "Responsable Technique",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Samuel hougbegnise",
          lastname: "M. Samuel ",
          firstname: "",
          image: sam,
          role: "Designer en Chef",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Siméon",
          lastname: "M. Siméon",
          firstname: "",
          image: simeon,
          role: "Développeur web",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Conceptia",
          lastname: "Mme Conceptia",
          firstname: "",
          image: conceptia,
          role: "Chargée de prospection commerciale",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Emmanuel",
          lastname: "M. Emmanuel",
          firstname: "",
          image: manu,
          role: "Chargé de prospection commerciale",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Vanessa",
          lastname: "Mme Vanessa ",
          firstname: "",
          image: vanessa,
          role: "Chargée de prospection commerciale",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Noël Gbeti",
          lastname: "M. Noël ",
          firstname: "",
          image: noel,
          role: "Responsable des Opérations",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Carlos",
          lastname: "M. Carlos ",
          firstname: "",
          image: carlos,
          role: "Chef d'équipe",
        },
        
        {
          alt: "Panneau mobile bénin. Vélo publicitaire Jolidon",
          lastname: "M. Aaron ",
          firstname: "",
          image: aaron,
          role: "Stagiaire",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Jolidon",
          lastname: "M. Jolidon ",
          firstname: "",
          image: jolidon,
          role: "Stagiaire",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Bertrand",
          lastname: "M. Bertrand ",
          firstname: "",
          image: bertrand,
          role: "Chef d'équipe",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Marius",
          lastname: "M. Marius ",
          firstname: "",
          image: marius,
          role: "Cycliste",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Godfroy",
          lastname: "M. Godfroy ",
          firstname: "",
          image: godfroy,
          role: "Cycliste",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire David",
          lastname: "M. David ",
          firstname: "",
          image: david,
          role: "Cycliste",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire John",
          lastname: "M. John ",
          firstname: "",
          image: john,
          role: "Cycliste",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Steeve",
          lastname: "M. Steeve ",
          firstname: "",
          image: steeve,
          role: "Cycliste",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Alexandre",
          lastname: "M. Alexandre ",
          firstname: "",
          image: alexandre,
          role: "Cycliste",
        },

        {
          alt: "Panneau mobile bénin. Vélo publicitaire Xavier",
          lastname: "M. Xavier ",
          firstname: "",
          image: xavier,
          role: "Commercial",
        },
      ],
    };
  },
};
</script>
<style>
.title {
  color: black;
}
img {
  object-fit: cover;
  border-radius: 5px;
}

@media screen and (max-width: 600px) {
  #membreImg {
    width: 100%;
    height: auto;
    border-radius: 5px;
  }
}
@media (min-width: 768px) {
  #membreImg {
    width: 100%;
    height: 250px;
    border-radius: 5px;
  }
}
@media (min-width: 1024px) {
  #membreImg {
    width: 100%;
    height: 250px;
    border-radius: 5px;
  }
}
.imgDiv {
  position: relative;
}
.imgDiv img{
  width: 100%;
}
.name{
  padding: 0px 8px 0px 8px;
}
.text-div {
  position: absolute;
  bottom: 10px;
  left: 20px;
}
.titre {
  display: flex;
  flex-direction: column;
  justify-content: space-around;  
  color: white;
  font-weight: 400;
  background-color: #53A12ED1;
  padding: 5px;
  width: max-content;
  border-radius: 30px;
  text-align: center;
}

.role {
  color: white;
  text-align: center;
  padding: 2px;
  display: none;
  margin-right: 10px;
}

@keyframes role {
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}
.imgDiv:hover {
  .role {
    animation: role 1s forwards;
    display: block;
  }
  .titre{
    transition-duration: 0.3s;
    background: linear-gradient(177.27deg, rgba(83, 162, 46, 0.82) 24.44%, rgba(41, 84, 21, 0.83) 97.8%);
    margin: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px; 
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px; 
    padding: 0px;
    width: calc(100% - 14.5px);
    height: 90px;
  }
  .text-div{
    width: 100%;
    bottom: 0px;
    left: 7px;
  }
}
</style>
